export * from './note-widget.component';
